import formatNumberCommas from 'Utils/formatNumberCommas'

interface Props {
	price: number
}

const TotalPriceCell: React.FC<Props> = ({ price }) => {
	return (
		<div className="text-end">
			<div className="text-kumopack-grey-900 fw-bolder fs-4">{formatNumberCommas(price)}</div>

			<div>บาท</div>
		</div>
	)
}

export default TotalPriceCell
